enum ProgrammeResourceType {
  revisionChecklist = "revisionChecklist",
  trainingPlan = "trainingPlan",
}

export default ProgrammeResourceType;
